const logInvariant = (error) => {
  console.error(error);
  if (typeof window !== "undefined" && window.__RICOS_LOG_INVARIANT__) {
    window.__RICOS_LOG_INVARIANT__(error);
  }
};
export {
  logInvariant
};
//# sourceMappingURL=log-invariant.js.map
